import styles from "./styles.module.css";

/* Drawn from design-system tokens instead of a flat PNG, so the artwork follows
 * the accent colour and reads correctly in both themes — the old raster image
 * carried a baked-in light background that sat as a white slab in dark mode.
 *
 * Everything here is decorative, hence aria-hidden: the modal's title and body
 * already carry the message for assistive tech. */
const Illustration = () => (
  <div className={styles.art} aria-hidden="true">
    <span className={`${styles.blob} ${styles.blobTop}`} />
    <span className={`${styles.blob} ${styles.blobBottom}`} />

    {}
    <div className={styles.window}>
      <div className={styles.windowBar}>
        <span />
        <span />
        <span />
      </div>
      <div className={styles.windowBody}>
        <span className={styles.lineLong} />
        <span className={styles.lineShort} />
        <div className={styles.progress}>
          <span className={styles.progressFill} />
        </div>
      </div>
    </div>

    {}
    <div className={styles.badge}>
      <svg viewBox="0 0 24 24" width="22" height="22" fill="none">
        <path
          d="M12 4v10m0 0 4-4m-4 4-4-4"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 17.5h14"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </div>

    <span className={styles.spark1} />
    <span className={styles.spark2} />
  </div>
);

export default Illustration;
